import {MI} from "../init";
import {MadnesObject} from "../libs/mi/MadnesObject";
import {getRandomFloat, getRandomInt} from "../../framework/src/helpers";
import {madnes_fill_range} from "../../framework/src/engine/madnes/madnes";
import {getRandRadius} from "../utils/helpers";

/**
 * @constructor
 * @returns {CoinsEmitter}
 */
export default function CoinsEmitter() {

    this._coins_positions = {};

    /** @type {Object<string,MadnesTimer>} */
    this._coins_big_win_anims = {
        "leftTop": null,
        "centerTop": null,
        "rightTop": null,
        "leftBottom": null,
        "centerBottom": null,
        "rightBottom": null
    };

    /** @type {GameGroups} */
    this._groups;

    /** @type {?MadnesTimer} */
    this._anim;
};

CoinsEmitter.prototype.showCoins = function() {
    this._groups.get("group_coins").setVisible(true);
};

CoinsEmitter.prototype.hideCoins = function() {
    this._groups.get("group_coins").setVisible(false);
};

/**
 * @param {GameGroups} groups
 */
CoinsEmitter.prototype.create = function(groups) {

    this._groups = groups;

    var game_width_half = (MI.getWi() / 2);
    var game_height_half =  (MI.getHe() / 2);

    //var center_top = (MI.getHe() / 2.7);
    var center_bottom = (MI.getHe() / 3.2);

    this._coins_positions = {
        'centerTop' : [
            { 'x': game_width_half, 'y': game_height_half /*center_top + 50*/, 'd': 50},
            { 'x': game_width_half, 'y': 250, 'd': 150},
            { 'x': game_width_half - 300, 'y': -500, 'd': 600},
            { 'x': game_width_half + 300, 'y': -500, 'd': 600}
        ],
        'leftTop': [
            { 'x': game_width_half/* - 120*/, 'y': game_height_half /*center_top + 30*/, 'd': 1 },
            { 'x': game_width_half - 240, 'y': 100, 'd': 120},
            { 'x': game_width_half - 750, 'y': -50, 'd': 500},
            { 'x': game_width_half - 800, 'y': 350/ MI.getMulti(), 'd': 500}
        ],
        'rightTop': [
            { 'x': game_width_half/* + 120*/, 'y': game_height_half /*center_top + 30*/, 'd': 0 },
            { 'x': game_width_half + 240, 'y': 200, 'd': 60},
            { 'x': game_width_half + 750, 'y': -50, 'd': 500},
            { 'x': game_width_half + 800, 'y': 350, 'd': 500}
        ],
        'leftBottom': [
            { 'x': game_width_half/* - 120*/, 'y': game_height_half /*center_bottom * 2 - 90*/, 'd': 0 },
            { 'x': game_width_half - 140, 'y': center_bottom * 2 - 10, 'd': 50},
            { 'x': game_width_half - 650, 'y': center_bottom * 2 + 250, 'd': 350},
            { 'x': game_width_half - 320, 'y': center_bottom * 2 + 320, 'd': 370}
        ],
        'centerBottom' : [
            { 'x': game_width_half, 'y': game_height_half /*center_bottom * 2 - 90*/, 'd': 0 },
            { 'x': game_width_half, 'y': 250, 'd': 150},
            { 'x': game_width_half - 200, 'y': 900, 'd': 500},
            { 'x': game_width_half + 200, 'y': 900, 'd': 500}
        ],
        'rightBottom' : [
            { 'x': game_width_half/* + 120*/, 'y': game_height_half /*center_bottom * 2 - 90*/, 'd': 0 },
            { 'x': game_width_half + 140, 'y': center_bottom * 2 - 10, 'd': 50},
            { 'x': game_width_half + 650, 'y': center_bottom * 2 + 250, 'd': 350},
            { 'x': game_width_half + 320, 'y': center_bottom * 2 + 320, 'd': 370}
        ],
        'center' : [
            { 'x': game_width_half, 'y': game_height_half, 'd': 0 },
            { 'x': game_width_half - 300, 'y': game_height_half - 400, 'd': 200},
            { 'x': game_width_half + 300, 'y': game_height_half - 400, 'd': 200}
            //{ x: wi / 2 - 200, y: he / 2 + 100, d: 300 },
            //{ x: wi / 2 + 200, y: he / 2 + 100, d: 300 }
        ]
    };
};

CoinsEmitter.prototype._getPointsPositions = function(pos, i) {
    return {
        'x': this._coins_positions[pos][i]['x'],
        'y': this._coins_positions[pos][i]['y'],
        'd': this._coins_positions[pos][i]['d']
    };
};

CoinsEmitter.prototype._coin_calc_pos = function(pos, d) {
    return (pos + getRandRadius(d)) | 0;
};

/**
 * @param {string} type
 * @param {number=} dir
 * @returns {Array}
 */
CoinsEmitter.prototype._generatePointsFor = function(type, dir) {

    var points = [];

    if(typeof dir === 'undefined')
    {
        dir = Math.random() >= 0.5 ? -1 : 1;
    }

    points.push({ 'x': this._getPointsPositions(type, 0)['x'], 'y': this._getPointsPositions(type, 0)['y'] });

    switch(type) {

        case "leftTop":
        case "rightTop":
        case "leftBottom":
        case "rightBottom":

            //p1 = getPointsPositions(type, 1);
            //points.push({ x: ((p1.x + getRandRadius(p1.d)) | 0), y: ((p1.y + getRandRadius(p1.d)) | 0) });

            if(dir < 0) {
                var p2 = this._getPointsPositions(type, 2);
            } else {
                var p2 = this._getPointsPositions(type, 3);
            }

            points.push({ 'x': ((p2['x'] + getRandRadius(p2['d'])) | 0), 'y': ((p2['y'] + getRandRadius(p2['d'])) | 0) });

            break;

        case "centerTop":
        case "centerBottom":

            if(Math.abs(getRandomInt(0, this._getPointsPositions(type, 1)['d'] / 2) * dir) < 30) {

                points.push({ 'x': ((MI.getWi() / 2 + getRandomInt(0, 600) * dir) | 0), 'y': type === "centerTop" ? -300 : MI.getHe() + 300 });

            } else {

                if(dir < 0) {
                    var p1 = this._getPointsPositions(type, 2);
                } else {
                    var p1 = this._getPointsPositions(type, 3);
                }

                points.push({ 'x': ((p1['x'] + getRandRadius(p1['d'])) | 0), 'y': ((p1['y'] + getRandRadius(p1['d'])) | 0) });
            }

            break;

        case "center":

            if(dir < 0) {

                var p1 = this._getPointsPositions(type, 1);
                points.push({ 'x': this._coin_calc_pos(p1['x'], p1['d']), y: this._coin_calc_pos(p1['y'], p1['d']) });

                var from = 120;
                to = (MI.getWi() / 2)- 160;

                points.push({ 'x': getRandomInt(from, to), 'y': MI.getHe() + 800});

            } else {

                var p1 = this._getPointsPositions(type, 2);
                points.push({ 'x': this._coin_calc_pos(p1['x'], p1['d']), y: this._coin_calc_pos(p1['y'], p1['d']) });

                var from = (MI.getWi() / 2)+ 160;
                var to =  MI.getWi() - 120;

                points.push({ 'x': getRandomInt(from, to), 'y': MI.getHe() + 800});
            }

            break;
    }

    return points;
};

/**
 * @param {Array} frames
 */
CoinsEmitter.prototype._randomize_coin_frames = function(frames) {

    var rIdx = getRandomInt(1, frames.length - 2);

    var a1 = frames.slice(0, rIdx);
    var a2 = frames.slice(rIdx, frames.length);

    return a2.concat(a1);
};

/**
 * @param {string} where
 * @param {boolean=} explode
 * @param {number=} dir
 */
CoinsEmitter.prototype._coin_add = function(where, explode, dir) {
    var _self = this;

    var coinId = "coin_" + ((Math.random() * 1000000) | 0);
    if(MadnesObject.keyExists(coinId)) {
        //console.log(coinId + " exists");
        return;
    }

    var pos = this._getPointsPositions(where, 0);
    var duration;

    if(explode) {
        duration = getRandomFloat(1.2, 1.8);
    } else if(where === "center") {
        duration = 1.8;
    } else {
        duration = getRandomFloat(1.2, 2.4);
    }

    var coinSprite = MI.addImg(pos['x'], pos['y'], "coins_atlas", coinId);
    coinSprite.setAnchor(0.5, 0.5);

    if(where === "center")
    {
        coinSprite.setScale(0.7, 0.7);
    }

    coinSprite.createAnims();
    coinSprite.anims.add("anim", MI.randomizeFrames(madnes_fill_range(0, 45)));
    coinSprite.anims.loop("anim");

    this._groups.get("group_coins").add(coinSprite);

    (function(coinSprite, where, dir) {

        var points = _self._generatePointsFor(where, dir);

        var xx = [];
        var yy = [];

        for(var i = 0; i < points.length; i++) {
            xx.push(points[i].x);
            yy.push(points[i].y);
        }

        MI.addTween().to(coinSprite, { 'x': xx, 'y': yy }, {
            'duration': (duration * 1000) | 0,
            //'easing': madnes_tween_func("linear"), //where === "center" ? madnes_tween_func("linear") : madnes_tween_func("quartic_in"),
            'callback': function() {
                coinSprite.anims.stop();
                coinSprite.destroy();
                coinSprite = null;
            }
        }).bezier();

    } (coinSprite, where, dir));
};

CoinsEmitter.prototype.bigwinPlay = function() {

    var _self = this;

    for(var type in this._coins_big_win_anims) {

        (function(type){
            _self._coins_big_win_anims[type] = MI.createTimer().loop(function() {
                _self._coin_add(type);
            }, 320);
        }(type));
    }
};

CoinsEmitter.prototype.bigwinStop = function() {

    for(var type in this._coins_big_win_anims) {
        this._coins_big_win_anims[type].stop();
    }
};

/**
 * @param {string} type
 */
CoinsEmitter.prototype.explodeBigwin = function(type) {

    var count = 10;

    switch(type) {
        case "megawin":
            count = 16;
            break;
        case "supermegawin":
            count = 24;
            break;
    }

    for(var i = 0; i < count; i++) {

        for(var j in this._coins_big_win_anims) {
            this._coin_add(j, true);
        }
    }
};

CoinsEmitter.prototype.winPlay = function() {

    var _self = this;

    this.showCoins();

    for(var i = 0; i < 6; i++) {
        this._coin_add("center", false, i % 2 === 0 ? -1 : 1);
        //console.log(i % 2 === 0 ? -1 : 1);
    }

    this._anim = MI.createTimer().loop(function() {

        _self._coin_add("center", false, -1);
        _self._coin_add("center", false, 1);

    }, 500);
};

CoinsEmitter.prototype.winStop = function() {
    this._anim && this._anim.stop();
    this._anim = null;
};